import _defineProperty from '../../node_modules/@babel/runtime/helpers/defineProperty.js';
import { CONFIGS } from './constants.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ZHL_CALC = 'zhlAffordabilityCalculator';
var initCalculatorConfigs = function initCalculatorConfigs(env) {
  window[ZHL_CALC] = _objectSpread({
    env: env
  }, CONFIGS[env]);
};
var getConfigs = function getConfigs() {
  var _window;
  if (!((_window = window) !== null && _window !== void 0 && _window[ZHL_CALC])) {
    // eslint-disable-next-line no-console
    console.error('zhl affordability calculator is not initialized yet');
    return {};
  }
  return window[ZHL_CALC];
};

export { getConfigs, initCalculatorConfigs };
//# sourceMappingURL=configs.js.map
